module.exports = __webpack_public_path__ + "img/E.4acd7b4b.jpg";